/* eslint-disable import/namespace */
import compact from 'lodash/compact';
import cond from 'lodash/cond';
import flow from 'lodash/flow';
import get from 'lodash/get';
import identity from 'lodash/identity';
import isArray from 'lodash/isArray';
import join from 'lodash/join';
import partial from 'lodash/partial';
import stubTrue from 'lodash/stubTrue';
import qs from 'query-string';

import * as Urls from '../constants/Urls';

const getParamFromArray = flow([compact, join]);

const parseParam = partial(
  get,
  qs.parse(decodeURIComponent(window.location.search.replace(/^\?/, '')))
);

export const getDomainUrl = () => {
  const pathname = get(window, 'location.pathname', '');
  const origin = get(window, 'location.origin', '');
  const routePath = pathname.replace(/^([^/]*\/[^/]*\/).*$/, '$1');
  const inAppRoute = Object.keys(Urls).some((keyProp) =>
    RegExp(`^${Urls[keyProp]}/?$`).test(routePath)
  );
  return inAppRoute ? origin : `${origin}${routePath.replace(/\/$/, '')}`;
};

export const fabricSSOUrl = (url, urlPath) => {
  const querySeparator = /(?:&?[^=&]*=[^=&]*)/.test(url) ? '&' : '?';
  const domainUrl = getDomainUrl();
  const returnUrl = `${domainUrl}${urlPath}`;

  return `${url}${querySeparator}returnUrl=${encodeURIComponent(returnUrl)}`;
};

export const getQsParam = flow([
  parseParam,
  cond([
    [isArray, getParamFromArray],
    [stubTrue, identity],
  ]),
]);
